<template>
  <div class="ability-business">
    <div class="ability-banner-wrapper">
      <div class="ability-banner-area w1200">
        <h1>商业变现</h1>
        <p>
          帮助商家完成开店、知识产品交付及变现需<br
            v-if="$store.state.sceneClassName !== 'app'"
          />求，打造商业变现闭环
        </p>
        <a href="/">立即创建体验</a>
      </div>
    </div>
    <div class="ability-block-list">
      <div class="ability-block-item">
        <div class="ability-block w1200">
          <div class="ability-block-text">
            <h1>品牌店铺全渠道曝光展示</h1>
            <p class="">
              全渠道经营场景：支持在公众号、小程序、朋友圈、微信群等多个终端获得曝光展示和内容变现，占据主流社交流量入口，实现品牌曝光和营销传播
            </p>
          </div>
          <img
            :src="require('@/assets/images/ability2.png')"
            alt=""
            class="ability-block-img"
          />
        </div>
      </div>
      <div class="ability-block-item">
        <div class="ability-block w1200 reverse">
          <div class="ability-block-text">
            <h1>根据品牌调性装修店铺</h1>
            <p class="">
              店铺风格：可根据自身品牌风格拖拽式自由组合，提供海量装修组件、行业模板搭配组合，支持实时预览，自定义店铺风格和配色方案
            </p>
          </div>
          <img
            :src="require('@/assets/images/ability3.png')"
            alt=""
            class="ability-block-img"
          />
        </div>
      </div>
      <div class="ability-block-item">
        <div class="ability-block w1200">
          <div class="ability-block-text">
            <h1>
              多形态内容<br
                v-if="$store.state.sceneClassName === 'app'"
              />适配不同传递场景
            </h1>
            <p class="">
              知识产品：全面支持图文、音频、视频、直播、电子书等内容服务形式。同时还支持专栏、会员、训练营组合内容交付形式
            </p>
          </div>
          <img
            :src="require('@/assets/images/ability4.png')"
            alt=""
            class="ability-block-img"
          />
        </div>
      </div>
      <div class="ability-block-item">
        <div class="ability-block w1200 reverse">
          <div class="ability-block-text">
            <h1>
              打造线上线下<br
                v-if="$store.state.sceneClassName === 'app'"
              />一体化服务流程
            </h1>
            <p class="">
              教务排课：智能排课避免撞课，可以设置课程预约和人数限制
            </p>
            <p class="mg">
              线下课：体验课来引导用户线下体验，轻松绑定微信买课、约课和签到
            </p>
          </div>
          <img
            :src="require('@/assets/images/ability5.png')"
            alt=""
            class="ability-block-img"
          />
        </div>
      </div>
      <div class="ability-block-item">
        <div class="ability-block w1200">
          <div class="ability-block-text">
            <h1>社群式助学服务实现督学</h1>
            <p class="">
              题库考试：自定义导入题库和试卷库，实现考试、作业本、练习及随堂测验，强化学习效果
            </p>
            <p class="mg">
              打卡：可创建日历打卡、作业打卡、考试打卡等玩法，形成督学玩法，提高学员活跃度
            </p>
          </div>
          <img
            :src="require('@/assets/images/ability6.png')"
            alt=""
            class="ability-block-img"
          />
        </div>
      </div>
      <div class="ability-block-item">
        <div class="ability-block w1200 reverse">
          <div class="ability-block-text">
            <h1>知识带货结合实物商品</h1>
            <p class="">
              课程带货：知识产品结合实物商品售卖，满足用户购买需要，并提高客单价，创造更多收益
            </p>
            <p class="mg">
              商品管理：对实物商品增减编辑和上下架，设置商品的名称/价格/库存/运费和详情描述等字段
            </p>
          </div>
          <img
            :src="require('@/assets/images/ability7.png')"
            alt=""
            class="ability-block-img"
          />
        </div>
      </div>
      <div class="ability-block-item">
        <div class="ability-block w1200">
          <div class="ability-block-text">
            <h1>智能订单管理与交易分析</h1>
            <p class="">
              流量和用户：自动分析店铺流量获客及用户活跃情况，呈现用户活跃及客户复购趋势
            </p>
            <p class="mg">
              商品和交易：清晰查看在售商品类别数量、付费排行以及单个商品访问和付费情况
            </p>
          </div>
          <img
            :src="require('@/assets/images/ability8.png')"
            alt=""
            class="ability-block-img"
          />
        </div>
      </div>
    </div>
    <div class="ability-bg_blue">
      <div class="ability-block-advantage w1200">
        <p class="advantage-title">知链的优势</p>
        <div class="advantage-list">
          <div class="advantage-item">
            <img :src="require('@/assets/images/ability9.png')" alt="" />
            <h6>专注知识产品变现</h6>
            <p>多年专注深耕知识付费，更专业的内容服务变现系统</p>
          </div>
          <div class="advantage-item">
            <img :src="require('@/assets/images/ability10.png')" alt="" />
            <h6>自主品牌展示</h6>
            <p>打通社交流量渠道，构建自主品牌展示矩阵</p>
          </div>
          <div class="advantage-item">
            <img :src="require('@/assets/images/ability11.png')" alt="" />
            <h6>完整的经营闭环</h6>
            <p>从品牌营销-内容交付变现-用户管理的经营闭环</p>
          </div>
          <div class="advantage-item">
            <img :src="require('@/assets/images/ability12.png')" alt="" />
            <h6>数据化经营分析</h6>
            <p>涵盖获客、交易、商品等的全流程经营数据分析</p>
          </div>
        </div>
        <div v-if="$store.state.sceneClassName !== 'app'" class="ct-eva-title">
          客户评价
        </div>
        <div
          v-if="$store.state.sceneClassName !== 'app'"
          class="ct-eva-content"
        >
          <img :src="require('@/assets/images/ability13.png')" />
          <div class="eva-description">
            <div class="eva-desc-title">21世纪经济报道</div>
            <div class="eva-desc-content">
              知链解决我们与内容的联动，通过知链内容市场能一键获取好课，大大节省了我们的时间成本。
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-case-list></v-case-list>
    <div class="ct-eva-box" v-if="$store.state.sceneClassName === 'app'">
      <div class="ct-eva-title">客户评价</div>
      <div class="ct-eva-content">
        <img :src="require('@/assets/images/ability13.png')" />
        <div class="eva-description">
          <div class="eva-desc-title">21世纪经济报道</div>
          <div class="eva-desc-content">
            知链解决我们与内容的联动，通过知链内容市场能一键获取好课，大大节省了我们的时间成本。
          </div>
        </div>
      </div>
    </div>
    <v-free
      v-if="$store.state.sceneClassName === 'app'"
      title="现在加入，立享新商家<br/>专享优惠礼包"
      href=""
    ></v-free>
    <v-free v-else title="现在加入，立享新商家专享优惠礼包" href=""></v-free>
  </div>
</template>

<script>
import Free from '@/components/Free';
import CaseList from '@/components/CaseList';
export default {
  data() {
    return {
      isOpen: false
    };
  },
  components: {
    'v-free': Free,
    'v-case-list': CaseList
  },
  methods: {
    openSee() {
      this.isOpen = true;
    }
  }
};
</script>

<style lang="scss">
.ability-business {
  .ability-banner-wrapper {
    position: relative;
    padding-top: 218px;
    height: 640px;
    width: 100%;
    color: #fff;
    background-color: #1472ff;
    background-image: url('~@/assets/images/ability1.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 640px;
  }
  .ability-banner-wrapper .ability-banner-area h1 {
    margin-bottom: 32px;
    font-size: 64px;
    line-height: 72px;
    font-weight: 600;
  }
  .ability-banner-wrapper .ability-banner-area p {
    margin-bottom: 72px;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    width: 400px;
  }
  .ability-banner-wrapper .ability-banner-area a {
    display: block;
    width: 144px;
    height: 44px;
    line-height: 44px;
    background: #fff;
    border-radius: 22px;
    color: #1472ff;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
  }
  .ability-banner-wrapper .ability-banner-area a:hover {
    background: #3d91ff;
    color: #fff;
  }
  .ability-banner-wrapper .ability-banner-area a:active {
    background: #1159d6;
    color: #fff;
  }
  .ability-bg_blue,
  .ability-block-item:nth-child(2n) {
    background-color: #f7fafe;
  }
  .class-room .bd img {
    width: 825px;
  }
  .pay-knowledge-img {
    width: 1225px;
  }
  .ability-block-item .reverse {
    flex-direction: row-reverse;
  }
  .ability-block-item .ability-block {
    align-items: center;
    height: 692px;
  }
  .ability-block-item .ability-block .ability-block-text {
    width: 468px;
  }
  .ability-block-item .ability-block .ability-block-text h1 {
    margin-bottom: 24px;
    font-size: 36px;
    font-weight: 500;
    color: #333;
    line-height: 44px;
  }
  .ability-block-item .ability-block .ability-block-text .mg80 {
    margin-bottom: 80px;
  }
  .ability-block-item .ability-block .ability-block-text h6 {
    margin-bottom: 32px;
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
  }
  .ability-block-item .ability-block .ability-block-text p {
    line-height: 24px;
    font-size: 16px;
    font-weight: 400;
    text-align: justify;
  }
  .ability-block-item .ability-block .ability-block-img {
    width: 668px;
  }
  .ability-block-item .ability-block,
  .three-arrow {
    justify-content: space-between;
    display: flex;
  }
  .mg {
    margin-top: 12px;
  }
  .ability-bg_blue,
  .ability-block-item:nth-child(2n) {
    background-color: #f7fafe;
  }
  .ability-block-advantage .advantage-item,
  .ability-block-advantage .ct-eva-content {
    background: #fff;
    -webkit-box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.04),
      0 0 20px 0 rgba(0, 0, 0, 0.03);
    box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.04), 0 0 20px 0 rgba(0, 0, 0, 0.03);
    border-radius: 8px;
  }
  .ability-block-advantage {
    padding: 96px 0;
  }
  .ability-block-advantage .advantage-title {
    margin-bottom: 64px;
    font-size: 36px;
    font-weight: 500;
    color: #333;
    line-height: 44px;
  }
  .ability-block-advantage .advantage-list {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .ability-block-advantage .advantage-item {
    padding: 40px 16px;
    width: 268px;
    height: 364px;
    margin-left: 32px;
    text-align: center;
  }
  .ability-block-advantage .advantage-item:first-child {
    margin-left: 0;
  }
  .ability-block-advantage .advantage-item img {
    margin-bottom: 24px;
    width: 176px;
    height: 176px;
  }
  .ability-block-advantage .advantage-item h6 {
    margin-bottom: 8px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    line-height: 28px;
  }
  .ability-block-advantage .advantage-item p {
    font-size: 16px;
    font-weight: 400;
    color: #666;
    line-height: 24px;
  }
  .ability-block-advantage .ct-eva-title {
    margin-top: 64px;
    font-size: 28px;
    font-weight: 500;
    color: #333;
    line-height: 36px;
  }
  .ability-block-advantage .ct-eva-content {
    margin-top: 32px;
    width: 1168px;
    height: 140px;
    padding-left: 16px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .ability-block-advantage .ct-eva-content img {
    width: 140px;
    height: 140px;
  }
  .ability-block-advantage .eva-description {
    margin-left: 16px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-top: 24px;
    color: #333;
  }
  .ability-block-advantage .eva-desc-title {
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
  }
  .ability-block-advantage .eva-desc-content {
    margin-top: 8px;
    width: 976px;
    height: 48px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
  .ability-block-advantage,
  .flex-column-center {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .case-list {
    background-color: #ffffff;
  }
}
.app .ability-business {
  padding-top: 1.04rem;
  .ability-banner-wrapper {
    height: 8.64rem;
    background-color: #1472ff;
    background-image: url('~@/assets/images/ability1_app.png');
    background-position: center;
    background-position-y: -0.96rem;
    background-size: cover;
    padding: 0.96rem 0.32rem 0;
    .ability-banner-area {
      text-align: center;
      h1 {
        margin-bottom: 0;
        font-size: 0.8rem;
        font-weight: 600;
        line-height: 0.88rem;
      }
      p {
        margin: 0.24rem auto 0;
        font-size: 0.32rem;
        font-weight: 400;
        line-height: 0.48rem;
        width: 5.6rem;
      }
      a {
        border: none;
        outline: 0;
        margin: 0.48rem auto 0;
        width: 3.2rem;
        height: 0.8rem;
        border-radius: 0.88rem;
        font-size: 0.32rem;
        font-weight: 500;
        line-height: 0.8rem;
      }
    }
  }
  .ability-block-item .ability-block,
  .three-arrow {
    display: block;
  }
  .ability-block-item .ability-block {
    height: auto;
    padding: 1.28rem 0.32rem;
    .ability-block-text {
      width: auto;
      h1 {
        font-size: 0.56rem;
        line-height: 0.72rem;
      }
      p {
        margin-top: 0.32rem;
        font-size: 0.28rem;
        line-height: 0.44rem;
      }
    }
    .ability-block-img {
      margin-top: 0.64rem;
      width: 100%;
    }
  }
  .ability-block-advantage {
    padding: 1.28rem 0.32rem;
    .advantage-title {
      font-size: 0.56rem;
      line-height: 0.72rem;
      margin-bottom: 0.96rem;
    }
    .advantage-list {
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .advantage-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0;
      width: 3.28rem;
      height: 5.56rem;
      border-radius: 0.16rem;
      margin-left: 0;
      h6 {
        height: 0.48rem;
        font-size: 0.32rem;
        font-weight: 500;
        color: #333;
        line-height: 0.48rem;
        margin-top: 0.32rem;
        margin-bottom: 0;
      }
      p {
        width: 2.32rem;
        margin-top: 0.16rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: #666;
        line-height: 0.44rem;
        height: 1.32rem;
      }
      img {
        width: 2.32rem;
        height: 2.32rem;
        margin: 0;
      }
      &:nth-child(n + 3) {
        margin-top: 0.96rem;
      }
    }
  }
  .case-list {
    background: #ffffff;
    padding-bottom: 0;
  }
  .ct-eva-box {
    padding: 0 0.32rem 1.12rem;
    background: #ffffff;

    .ct-eva-title {
      margin-top: 0.96rem;
      font-size: 0.4rem;
      line-height: 0.57rem;
      text-align: center;
    }
    .ct-eva-content {
      margin-top: 0.96rem;
      width: 6.86rem;
      background: #fff;
      padding: 0.32rem;
      font-size: 0.24rem;
      line-height: 0.48rem;
      display: flex;
      box-shadow: 0 0.2rem 0.6rem 0 rgba(102, 102, 102, 0.08);
      border-radius: 0.16rem;
      img {
        width: 1.6rem;
        height: 1.6rem;
      }
      .eva-description {
        margin-left: 0.32rem;
        display: flex;
        flex-direction: column;
        font-size: 0.24rem;
        line-height: 0.48rem;
        text-align: left;
      }
      .eva-desc-title {
        font-weight: 500;
      }
      .eva-desc-content {
        font-weight: 400;
      }
    }
  }
}
</style>
